import { createContext, useContext, useState } from 'react';

interface ProtectedModalContextType {
  open: boolean;
  setOpen: (open: boolean) => void;
}
const ProtectedModalContext = createContext<ProtectedModalContextType | null>(
  null,
);

interface ProtectedModalProviderProps {
  children: React.ReactNode;
}

export const ProtectedModalProvider: React.FC<ProtectedModalProviderProps> = ({
  children,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <ProtectedModalContext.Provider value={{ open, setOpen }}>
      {children}
    </ProtectedModalContext.Provider>
  );
};

export const useProtectedModal = (): ProtectedModalContextType => {
  const context = useContext(ProtectedModalContext);

  if (!context) {
    throw new Error(
      'useProtectedModal must be used within a ProtectedModalProvider',
    );
  }

  return context;
};
